import React from 'react';

const GREEN = '#4cbb17';

const FolderIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={GREEN} width="96" height="96">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M0 1H5L8 3H13V5H3.7457L2.03141 11H4.11144L5.2543 7H16L14 14H0V1Z" fill={GREEN}></path>
    </g>
  </svg>
);

const TypewriterIcon = () => (
  <svg fill={GREEN} version="1.2" baseProfile="tiny" id="H1" xmlns="http://www.w3.org/2000/svg"
    viewBox="-63 65 128 128" xmlSpace="preserve" width="96" height="96">
    <g>
      <rect x="-30.2" y="76.9" width="62.5" height="5.2"/>
      <rect x="-30.2" y="87.3" width="62.5" height="5.2"/>
      <rect x="-30.2" y="97.8" width="62.5" height="5.2"/>
      <path d="M58.3,103c2.9,0,5.2-2.3,5.2-5.2v-5.2c0-2.9-2.3-5.2-5.2-5.2h-5.2c0-5.8-4.7-10.4-10.4-10.4V66.5h-83.4v10.4
        c-5.7,0-10.4,4.7-10.4,10.4h-5.2c-2.9,0-5.2,2.3-5.2,5.2v5.2c0,2.9,2.3,5.2,5.2,5.2h5.2v5.2c-5.8,0-10.4,4.7-10.4,10.4V181
        c0,5.8,4.7,10.4,10.4,10.4H53.1c5.8,0,10.4-4.7,10.4-10.4v-62.4c0-5.8-4.7-10.4-10.4-10.4V103H58.3z M-35.5,71.7h72.9v36.5H19.1
        c-3.6,6.2-10.3,10.5-18.1,10.5s-14.4-4.3-18-10.5h-18.5V71.7z M36.2,130.3c0,2.2-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9
        S36.2,128.1,36.2,130.3z M-30.2,134.2c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S-28,134.2-30.2,134.2z M-26.3,161.5
        c0,2.2-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9S-26.3,159.3-26.3,161.5z M-22.4,142c2.2,0,3.9,1.7,3.9,3.9
        c0,2.2-1.7,3.9-3.9,3.9c-2.2,0-3.9-1.7-3.9-3.9C-26.3,143.7-24.6,142-22.4,142z M-14.6,157.6c2.2,0,3.9,1.7,3.9,3.9
        s-1.7,3.9-3.9,3.9c-2.2,0-3.9-1.7-3.9-3.9C-18.5,159.4-16.8,157.6-14.6,157.6z M-14.6,134.2c-2.2,0-3.9-1.7-3.9-3.9
        s1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9S-12.4,134.2-14.6,134.2z M-6.8,142c2.2,0,3.9,1.7,3.9,3.9c0,2.2-1.7,3.9-3.9,3.9
        s-3.9-1.7-3.9-3.9C-10.7,143.7-9,142-6.8,142z M1,157.6c2.2,0,3.9,1.7,3.9,3.9s-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9
        C-2.9,159.4-1.1,157.6,1,157.6z M1,134.2c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S3.2,134.2,1,134.2z M8.8,142
        c2.2,0,3.9,1.7,3.9,3.9c0,2.2-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9C4.9,143.7,6.6,142,8.8,142z M16.6,157.6c2.2,0,3.9,1.7,3.9,3.9
        s-1.7,3.9-3.9,3.9c-2.2,0-3.9-1.7-3.9-3.9C12.7,159.4,14.5,157.6,16.6,157.6z M16.6,134.2c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9
        c2.2,0,3.9,1.7,3.9,3.9S18.8,134.2,16.6,134.2z M24.4,142c2.2,0,3.9,1.7,3.9,3.9c0,2.2-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9
        C20.5,143.7,22.2,142,24.4,142z M-45.9,134.2c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9
        S-43.7,134.2-45.9,134.2z M-38.1,149.8c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9
        C-34.2,148.1-35.9,149.8-38.1,149.8z M32.3,181.1h-62.5c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9h62.5c2.2,0,3.9,1.7,3.9,3.9
        C36.2,179.3,34.4,181.1,32.3,181.1z M32.3,165.5c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9
        C36.2,163.7,34.4,165.5,32.3,165.5z M40.1,149.8c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9
        C44,148.1,42.2,149.8,40.1,149.8z M47.9,134.2c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S50,134.2,47.9,134.2z"/>
    </g>
  </svg>
);

const PaperIcon = ({ color = GREEN }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" width="200" height="100">
    <path fill={color} d="M40 45H8V3h22l10 10z"/>
    <path fill="rgba(76,187,23,0.4)" d="M38.5 14H29V4.5z"/>
    <path fill="rgba(76,187,23,0.6)" d="M16 21h17v2H16zm0 4h13v2H16zm0 4h17v2H16zm0 4h13v2H16z"/>
  </svg>
);

const RobotIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="96" height="96" fill="none">
    {/* Antenna */}
    <line x1="24" y1="2" x2="24" y2="9" stroke={GREEN} strokeWidth="2" strokeLinecap="round"/>
    <circle cx="24" cy="2" r="2" fill={GREEN}/>
    {/* Head */}
    <rect x="9" y="9" width="30" height="20" rx="3" stroke={GREEN} strokeWidth="2"/>
    {/* Eyes */}
    <rect x="14" y="15" width="7" height="6" rx="1" fill={GREEN}/>
    <rect x="27" y="15" width="7" height="6" rx="1" fill={GREEN}/>
    {/* Mouth */}
    <rect x="15" y="24" width="4" height="2" fill={GREEN}/>
    <rect x="22" y="24" width="4" height="2" fill={GREEN}/>
    <rect x="29" y="24" width="4" height="2" fill={GREEN}/>
    {/* Neck */}
    <rect x="21" y="29" width="6" height="3" fill={GREEN}/>
    {/* Body */}
    <rect x="11" y="32" width="26" height="14" rx="2" stroke={GREEN} strokeWidth="2"/>
    {/* Arms */}
    <rect x="4" y="33" width="5" height="10" rx="2" stroke={GREEN} strokeWidth="2"/>
    <rect x="39" y="33" width="5" height="10" rx="2" stroke={GREEN} strokeWidth="2"/>
    {/* Chest buttons */}
    <circle cx="19" cy="39" r="2.5" fill={GREEN}/>
    <circle cx="29" cy="39" r="2.5" fill={GREEN}/>
  </svg>
);

const TerminalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="96" height="96" fill="none">
    {/* Monitor frame */}
    <rect x="4" y="6" width="40" height="30" rx="2" stroke={GREEN} strokeWidth="2.5"/>
    {/* Prompt chevron */}
    <path d="M11 15l7 6-7 6" stroke={GREEN} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Cursor line */}
    <rect x="22" y="25" width="12" height="2.5" fill={GREEN}/>
    {/* Stand */}
    <rect x="20" y="36" width="8" height="4" fill={GREEN}/>
    <rect x="14" y="40" width="20" height="2.5" rx="1" fill={GREEN}/>
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="96" height="96">
    <path fill={GREEN} d="M24 21v20h-8V21h8M32 21v20h-6V21h6M34 18H14v24c0 1.104.896 2 2 2h16c1.104 0 2-.896 2-2V18z"/>
    <path fill={GREEN} d="M12 16v2h24v-2c0-1.104-.896-2-2-2h-6v-2c0-1.104-.896-2-2-2h-4c-1.104 0-2 .896-2 2v2h-6c-1.104 0-2 .896-2 2z"/>
  </svg>
);

export { FolderIcon, TypewriterIcon, PaperIcon, TrashIcon, RobotIcon, TerminalIcon };
